import React, { useEffect, useState } from 'react';

/**
 * KixxYoutubeReport: KIXX Sports Club için YouTube TR içerik formatı araştırması.
 * Route: /r/kixx-youtube (ProtectedRoute allowEmails, sidebar YOK)
 *
 * KIXX platformda bir marka değil (statik site müşterisi), bu yüzden Europcar
 * raporlarındaki `allowBrandIds` deseni değil, Mimic/On Türkiye'deki
 * `requireBrand={false}` + e-posta izni deseni kullanıldı.
 *
 * İçerik markadan bağımsız statik bir rapor — API çağrısı yok. Veri 5 Ağu 2026'da
 * YouTube Data API v3'ten çekildi (31 kanal / 1.791 video) ve HTML'e gömülü.
 *
 * Rapor iframe içinde çalışır: kendi CSS'i `:root`, `body`, `h1`, `table` gibi
 * global seçiciler taşıyor; srcDoc izolasyonu dashboard'un stilini korur.
 *
 * HTML modülü ~49KB. Deck kadar büyük değil ama ana bundle'da işi olmadığı için
 * yine dinamik import ile yükleniyor.
 */
export default function KixxYoutubeReport() {
  const [html, setHtml] = useState(null);

  useEffect(() => {
    let alive = true;
    import('./kixxYoutubeReportHtml')
      .then((mod) => { if (alive) setHtml(mod.default); })
      .catch(() => {
        if (alive) setHtml('<p style="font:14px sans-serif;padding:24px;color:#eee">Rapor yüklenemedi.</p>');
      });
    return () => { alive = false; };
  }, []);

  const fill = { position: 'fixed', inset: 0, width: '100vw', height: '100vh', border: 0 };

  // Yükleme zemini raporun kendi zeminiyle aynı (#0B0D0B) — beyaz flaş olmasın.
  if (!html) return <div style={{ ...fill, background: '#0B0D0B' }} />;

  return (
    <iframe
      title="KIXX · YouTube TR İçerik Araştırması"
      srcDoc={html}
      style={fill}
    />
  );
}
